<template>
  <div style="width: 33%;">
    <div class="wxtip" v-show="wxTipShow" @click.self="wxTipShow = false">
      <span class="wxtip-icon"></span>
    </div>
    <div class="feature_export" @click="openTips">
      <van-image
        class="icon"
        fit="fill"
        :src="require('@/../static/icon-export.png')"
      ></van-image>
      导出数据
    </div>
    <van-popup v-model="show" round>
      <div class="export_popup">
        <div class="title">{{ all ? ope.text : area.areaName }}数据导出</div>
        <div class="time-picker-box">
          <div class="picker">
            <div class="startTime" @click="showCalendar('start')">
              {{ startTime ? startTime : '开始时间' }}
            </div>
            到
            <div class="endTime" @click="showCalendar('end')">
              {{ endTime ? endTime : '结束时间' }}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="contents">
            <download-excel
              class="export-excel-wrapper"
              :data="json_data"
              :fields="json_fields"
              :before-generate="beforeHandle"
              type="xls"
              :name="`${getFileName}出入库明细.xls`"
            >
              <van-button
                class="button"
                type="primary"
                round
                @click="exportType = '出入库明细'"
                >出入库明细</van-button
              >
            </download-excel>
            <download-excel
              class="export-excel-wrapper"
              :data="json_data"
              :fields="json_fields"
              :before-generate="beforeHandle"
              type="xls"
              :name="`${getFileName}派送品牌明细.xls`"
            >
              <van-button
                class="button"
                type="primary"
                round
                @click="exportType = '派送品牌明细'"
                >派送品牌明细</van-button
              >
            </download-excel>
          </div>
        </div>
      </div>
    </van-popup>
    <van-calendar
      v-model="calendarShow"
      ref="calendar"
      :min-date="new Date('2020-01-01')"
      :max-date="new Date()"
      row-height="30"
      :show-confirm="false"
      @confirm="calenderConfirm"
    />
  </div>
</template>
<script>
import JsonExcel from 'vue-json-excel'
import ExcelConfig from './cabExcelConfig.js'
export default {
  props: {
    id: String,
    area: Object,
    dateOptions: Array,
    dates: Array,
    ope: Object
  },
  components: { downloadExcel: JsonExcel },

  data() {
    return {
      isWeixin: false, // 是否微信打开
      wxTipShow: false, // 引导浏览器打开
      // exportShow: false,
      show: false,
      json_fields: {},
      json_data: [],
      startTime: '',
      endTime: '',
      calendarShow: false,
      time: '',
      title: '',
      exportType: '',
      all: false
    }
  },
  created() {
    var ua = navigator.userAgent
    var isWeixin =
      !!/MicroMessenger/i.test(ua) ||
      !!/MQQBrowser/i.test(ua) ||
      !!/QQTheme/i.test(ua)
    this.isWeixin = isWeixin
    let date = new Date()
    this.startTime = this.endTime = this.formatDate(date)
    this.all = this.$route.query.ope === 'all'
  },
  mounted() {
    this.title = document.title
  },
  computed: {
    getFileName() {
      let begin = this.all ? this.ope.text : this.area.areaName
      let str = `${begin}${this.startTime}`
      if (this.startTime !== this.endTime) {
        str = `${begin}${this.startTime}到${this.endTime}`
      }
      return str
    }
  },
  methods: {
    openTips() {
      this.show = true
    },
    async beforeHandle() {
      this.json_data = []
      if (this.isWeixin) {
        // 引导浏览器打开
        this.wxTipShow = true
        return
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        this.$toast('请选择正确的时间段')
        return
      }
      const params = this.getParams()
      const url = ExcelConfig[this.exportType].url
      const data = await this.$api.tyCab[url](params)
      if (data.length === 0) {
        this.$toast('无数据')
        return
      }
      this.json_data = data
      this.json_fields = ExcelConfig[this.exportType].header
    },
    getParams() {
      return {
        operationGroupId: this.id,
        cabinetId: '',
        dateBegin: this.startTime,
        dateEnd: this.endTime
      }
    },
    // 选择时间
    chooseDateItem(index) {
      this.dateType = index
      if (index !== 4) {
        this.$refs.date.toggle()
        // this.dateChange()
      }
    },
    showCalendar(e) {
      // this.$refs.date.toggle()
      this.time = e + 'Time'
      this.calendarShow = true
      let date = this[e + 'Time'] ? new Date(this[e + 'Time']) : ''
      if (date) this.$refs.calendar.reset(date)
      else this.$refs.calendar.reset()
    },

    calenderConfirm(value) {
      const time = this.formatDate(value)
      // this.calendarShow = false
      this[this.time] = time
      this.calendarShow = false
    },
    formatDate(date, type = 0) {
      if (type) {
        date = date.date
      }
      let myyear = date.getFullYear()
      let mymonth = date.getMonth() + 1
      let myweekday = date.getDate()
      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      return myyear + '-' + mymonth + '-' + myweekday
    }
  }
}
</script>
<style lang="scss" scoped>
.feature_export {
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 33%;
  font-size: 15px;
  .icon {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }
}
.export_popup {
  box-sizing: border-box;
  width: calc(100vw - 60px);
  max-width: 400px;
  min-width: 300px;
  padding: 20px;
  .title {
    font-size: 20px;
    text-align: center;
  }
  .content {
    display: flex;
    justify-content: center;
    .contents {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-content: center;
    }
    .export-excel-wrapper {
      box-sizing: border-box;
      width: 100%;
      padding: 10px;
    }
    .button {
      box-sizing: border-box;
      width: 100%;
    }
  }
}
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
}
.wxtip-icon {
  width: 161px;
  height: 100px;
  background: url('../../../../static/cue.png') no-repeat;
  background-size: contain;
  display: block;
  position: absolute;
  right: 5px;
  top: 0px;
}
.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.time-picker-box {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .picker {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .confirmPicker {
    margin-top: 10px;
    width: 50%;
  }
  .startTime,
  .endTime {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45%;
    height: 30px;
    border-radius: 15px;
    background-color: #f4f6fa;
  }
}
</style>
